import { RequestUpgrade } from "helpers/backend_helper"
import { useLoading } from "helpers/custom_hooks"
import React, { useState } from "react"
import { Alert, Modal, ModalBody } from "reactstrap"

const AccountUpgradeModal = ({ show, onCancel, onSuccess }) => {
  const [billingPeriod, setBillingPeriod] = useState("anual")
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState()
  const setLoading = useLoading()

  const handleSubmit = async () => {
    try {
      setLoading(true)
      await RequestUpgrade({ billingPeriod })
      setSuccess(true)
    } catch (error) {
      console.log(error)
      setError("An unexpected error happened! Please try again later")
    }
    setLoading(false)
  }

  return (
    <Modal size="m" isOpen={show} toggle={onCancel} centered={true}>
      <div className="modal-content">
        {!success ? (
          <ModalBody className="px-4 py-5 pb-3 text-center">
            <button
              type="button"
              onClick={onCancel}
              className="btn-close position-absolute end-0 top-0 m-3"
            ></button>
            {error ? <Alert color="danger">{error}</Alert> : null}

            <h4>Account Upgrade</h4>
            <p className="text-muted mb-4">
              We will send you an invoice for your upgrade. Once you have paid
              your invoice, we will upgrade your account. Please select your
              billing period.
            </p>

            <select
              className="form-select mb-4"
              onChange={e => {
                setBillingPeriod(e.target.value)
              }}
            >
              <option value="anual">Anual (500 € - per year)</option>
              <option value="half-yearly">
                Half-Yearly (250 € - per half year)
              </option>
            </select>

            <div className="hstack gap-2 justify-content-center mb-0">
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={onCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </ModalBody>
        ) : (
          <ModalBody className="px-4 py-5 pb-3 text-center">
            <button
              type="button"
              onClick={onCancel}
              className="btn-close position-absolute end-0 top-0 m-3"
            ></button>
            <h4>Thank you!</h4>

            <p className="text-muted mb-4">
              Thank you for your request. Our support team is working on it and
              will address it as quickly as possible.
            </p>

            <div className="hstack gap-2 justify-content-center mb-0">
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={_ => {
                  onSuccess()
                }}
              >
                Close
              </button>
            </div>
          </ModalBody>
        )}
      </div>
    </Modal>
  )
}

export default AccountUpgradeModal
